import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import {
  CreateProviderFeeRequest,
  PaginatedProviderFeeResponse,
  ProviderFeeDictAggregatorResponse,
  ProviderFeeResponse,
  UpdateProviderFeeRequest,
} from '@/open-api/models';
import { BaseApi } from '@/api/base-api';
import { ProvidersFeesGetListRequest } from '@/api/request/providers-fees/providers-fees-get-list.request';

export class ProvidersFeesApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/providers-fees';

  public listProvidersFees(
    query: ProvidersFeesGetListRequest,
  ): Promise<PaginatedProviderFeeResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/providers-fees?${this.queryToQueryString(query)}`,
      {},
    );
  }

  public getProvidersFeesDist(): Promise<ProviderFeeDictAggregatorResponse[]> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/providers-fees/dict`,
      {},
    );
  }

  public createProviderFeeItem(
    dto: CreateProviderFeeRequest,
  ): Promise<ProviderFeeResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[POST] /api/v1/providers-fees`,
      dto,
    );
  }

  public updateProviderFeeItem(
    id: number,
    dto: UpdateProviderFeeRequest,
  ): Promise<ProviderFeeResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/providers-fees/${id}`,
      dto,
    );
  }

  public deleteProviderFeeItem(id: number): Promise<void> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[DELETE] /api/v1/providers-fees/${id}`,
      {},
    );
  }
}
